/**
 * Language toggle — botão PT/EN que alterna entre os dois idiomas.
 *
 * Mostra o idioma OPOSTO no label (clicar em "EN" troca para EN).
 * Suporta múltiplos botões (header desktop + mobile menu).
 */

import { getLanguage, setLanguage, onLanguageChange, type Lng } from '../lib/i18n';

function nextLng(current: Lng): Lng {
  return current === 'pt' ? 'en' : 'pt';
}

function updateLabel(button: Element, current: Lng): void {
  const label = button.querySelector<HTMLElement>('[data-lang-label]');
  if (!label) return;
  // O label mostra o PRÓXIMO idioma para deixar claro o que o click faz.
  label.textContent = nextLng(current).toUpperCase();
}

function bindButton(button: HTMLElement): () => void {
  const apply = (): void => updateLabel(button, getLanguage());
  const onClick = (): void => {
    void setLanguage(nextLng(getLanguage()));
  };

  apply();
  button.addEventListener('click', onClick);

  return () => {
    button.removeEventListener('click', onClick);
  };
}

export function initLanguageToggle(): () => void {
  const buttons: HTMLElement[] = [];
  ['languageToggle', 'languageToggleMobile'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) buttons.push(el);
  });

  if (buttons.length === 0) return () => {};

  const cleanups: Array<() => void> = buttons.map(bindButton);

  cleanups.push(
    onLanguageChange((lng) => {
      buttons.forEach((b) => updateLabel(b, lng));
    }),
  );

  return () => {
    cleanups.forEach((fn) => fn());
  };
}
